import { useContext, useDebugValue } from 'react'

import AuthContext from '../contexts/AuthContext'

const useAuth = () => {
  const { auth } = useContext(AuthContext)
  useDebugValue(auth?.user ? 'Logged In' : 'Logged Out')
  return useContext(AuthContext)
}

export default useAuth
